module.exports = __webpack_public_path__ + "img/logo.91d4e437.png";